<template>
    <v-layout row>      
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <div v-if="isMobile" class="apps-container">
                        <v-menu left offset-y >
                            <template v-slot:activator="{ on }">
                                <v-list-tile-avatar>
                                    <v-btn flat dark icon small v-on="on">
                                        <v-icon>apps</v-icon>
                                    </v-btn>
                                </v-list-tile-avatar>
                            </template>
                            <v-list>
                                <v-list-tile>
                                    <v-btn icon small title="View Today" @click="viewToday" :disabled="loading">
                                        <v-icon>today</v-icon>
                                    </v-btn>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-btn icon to="/myattendance/calendar" title="View My Calendar">
                                        <v-icon>far fa-calendar-alt</v-icon>
                                    </v-btn>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-btn v-show="canAddAttendanceCorrections&&!futureDate" icon title="File Attendance Corrections" @click="showAddEditAttCorrections" :disabled="disableConditions||!withAssignedWorkShift">
                                        <v-icon>alarm_on</v-icon>
                                    </v-btn>
                                </v-list-tile>
                                <v-list-tile >
                                    <v-btn icon title="Add Personal Time Off" @click="showPTO" :disabled="disableConditions">
                                        <v-icon>work_off</v-icon>
                                    </v-btn>
                                </v-list-tile>
                                <v-list-tile>
                                    <v-btn icon title="Add Overtime" @click="showOvertime" :disabled="disableConditions">
                                        <v-icon>far fa-calendar-plus</v-icon>
                                    </v-btn>
                                </v-list-tile>
                                <v-list-tile>
                                    <help-link appId="attendance" pageId="myattendance" color="black"></help-link>
                                </v-list-tile>
                            </v-list>
                        </v-menu>
                    </div>
                    <div v-else class="apps-container">
                        <v-btn dark icon small title="View Today" @click="viewToday" :disabled="loading">
                            <v-icon>today</v-icon>
                        </v-btn>
                        <v-btn dark icon small to="/myattendance/calendar" title="View My Calendar" :disabled="loading" v-if="!isMobile">
                            <v-icon>far fa-calendar-alt</v-icon>
                        </v-btn>
                        <v-btn v-show="canAddAttendanceCorrections&&!futureDate" dark icon title="File Attendance Corrections" @click="showAddEditAttCorrections" :disabled="disableConditions||!withAssignedWorkShift">
                            <v-icon>alarm_on</v-icon>
                        </v-btn>
                        <v-btn dark icon title="File Time Off" @click="showPTO" :disabled="disableConditions">
                            <v-icon>work_off</v-icon>
                        </v-btn>
                        <v-btn v-show="!futureDate" dark icon title="File Overtime" @click="showOvertime" :disabled="disableConditions">
                            <v-icon>far fa-calendar-plus</v-icon>
                        </v-btn>
                        <help-link appId="attendance" pageId="myattendance" color="white"></help-link>
                    </div>
                    
                    <v-spacer></v-spacer>
                    <v-btn dark icon small title="View Previous Day"  @click="viewPrevious" style="margin-right:-10px;" :disabled="loading">
                        <v-icon>chevron_left</v-icon>
                    </v-btn>
                    <v-toolbar-title v-if="currentDate" class="subheading transparent white--text">Today&nbsp;&nbsp;</v-toolbar-title>
                    <v-toolbar-title v-if="!currentDate" class="subheading transparent white--text">{{ transDate | moment("DD MMM") }}</v-toolbar-title>
                    <v-btn dark icon small title="View Next Day" @click="viewNext" :disabled="loading">
                        <v-icon>chevron_right</v-icon>
                    </v-btn>               
                </v-toolbar>
                <!-- <v-progress-linear v-if="loading" indeterminate color="primary" height="3" style="margin:1px -5px 0px -3px;"></v-progress-linear> -->
            </v-card>
            <v-layout row wrap class="mt-1"> 
                <v-flex xs12>
                    <v-alert v-if="error" :value="true" color="error" icon="error" outline class="alert">
                        {{errorMessage}}    
                    </v-alert>
                    <v-alert v-if="!loading&&!withAssignedWorkShift" :value="true" color="warning" icon="warning" outline class="alert">
                        You have no assigned work shift for this date.
                    </v-alert>
                    <v-alert v-if="isHoliday" :value="true" color="info" icon="info" outline class="alert">
                        {{holidayDescription}}    
                    </v-alert>
                    <div v-if="!hasCutoffData">
                        <v-alert :value="true" color="warning" icon="warning" outline class="alert">
                            Cutoff period has not been created for this date.
                        </v-alert>
                    </div>
                    <div v-else>
                        <v-alert v-if="cutOffStatus==commonfn.getStatusCode('Frozen')" :value="true" color="warning" icon="warning" outline class="alert">
                            This period is frozen. Changes to Corrections, Tasks, Time Off, and Overtime are not allowed.
                        </v-alert>  
                        <v-alert v-if="cutOffStatus==commonfn.getStatusCode('Closed')" :value="true" color="warning" icon="warning" outline class="alert">
                            This period is closed. Changes to Corrections, Tasks, Time Off, and Overtime are not allowed.
                        </v-alert> 
                        <v-alert v-if="timeReportStatus==commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline class="alert">
                            This timesheet has already been approved. Changes to Corrections, Tasks, Time Off, and Overtime are not allowed.
                        </v-alert> 
                    </div>

                    <v-card v-if="!hasAttendance" class="elavation-1 mb-10"> 
                        <v-toolbar flat :height="isMobile? 50 : 40">
                            <b>Attendance</b>
                            <v-spacer></v-spacer>
                            <v-chip small v-if="my_data.workShifts" :style="`background-color:${my_data.workShifts.color}; `">
                                {{workshift}}
                            </v-chip>
                        </v-toolbar>
                        <v-card-text class="ml-10">
                            No data found
                        </v-card-text>
                    </v-card>

                    <!--clock-in section-->
                    <v-card class="elavation-1 mb-10" v-if="!loading && hasAttendance"> 
                        <v-toolbar flat height="45px">
                            <b>Attendance</b>
                            <v-spacer></v-spacer>
                            <v-chip v-if="my_data.workShifts" :style="`background-color:${my_data.workShifts.color}; margin-left:-5px;`">
                                {{workshift}}
                            </v-chip>               
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile? headers_attendance_mobile : headers_attendance"
                            :items="[my_data.attendance]"
                            hide-actions
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr>
                                    <td>Clock-In</td>
                                    <td :title="$moment(props.item.clockIn).format('MMM DD, YYYY h:mm a')" style="cursor:pointer">{{ props.item.clockIn | moment("h:mm a") }}</td>
                                    <td style="padding:3px 0px 3px 10px;">
                                        <v-img v-if="!props.item.uploaded" :src="commonfn.getAttendanceThumbPicUrl(props.item.userId, $moment(props.item.transDate).format('YYYY-MM-DD'), 'ClockIn')" height="50" width="50" @click="showPicViewer(props.item, 'ClockIn')" style="cursor:pointer;border-radius:6px;"></v-img>  
                                    </td>
                                    <td>{{ props.item.clockInDevice }}</td>
                                    <td v-if="!isMobile">{{ props.item.clockInRemarks }}</td>
                                </tr>
                                <tr>
                                    <td>Clock-Out</td>
                                    <td :title="$moment(props.item.clockOut).format('MMM DD, YYYY h:mm a')" style="cursor:pointer">{{ props.item.clockOut | moment("h:mm a") }}</td>
                                    <td style="padding:3px 0px 3px 10px;">
                                        <v-img v-if="!props.item.uploaded" :src="commonfn.getAttendanceThumbPicUrl(props.item.userId, $moment(props.item.transDate).format('YYYY-MM-DD'), 'ClockOut')" height="50" width="50" @click="showPicViewer(props.item, 'ClockOut')" style="cursor:pointer;border-radius:6px;"></v-img>  
                                    </td>
                                    <td>{{ props.item.clockOutDevice }}</td>
                                    <td v-if="!isMobile">{{ props.item.clockOutRemarks }}</td>
                                </tr>
                            </template>
                            <template v-slot:footer v-if="my_data.attendance.clockIn && my_data.attendance.clockOut">
                                <tr>
                                    <td colspan="5"> 
                                        Total:&nbsp;<b>{{my_data.attendance.totalHours}}</b> |
                                        Chargeable:&nbsp;<b>{{my_data.attendance.chargeableHours}}</b> |
                                        Late:&nbsp;<b>{{my_data.attendance.minsLate}}</b>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>

                    <!--Attendance Corrections section-->             
                    <v-card class="elavation-1 mb-10" v-if="!loading && hasAttendanceCorrection"> 
                        <v-toolbar flat height="35px">
                            <span class="font-weight-bold ">Attendance Corrections</span>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile?headers_attendance_corrections_mobile:headers_attendance_corrections"
                            :items="[my_data.attendanceCorrection]"
                            hide-actions
                            item-key="attendanceCorrectionsId"
                            :expand="expand"   
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr @click="viewAttendanceCorrections(props.item)" title="Click to edit/delete Attendance Corrections" class="clickable">                                      
                                    <td>
                                        <span v-if="isMobile">{{ props.item.transDate | moment("MMM DD") }}</span>
                                        <span v-else>{{ props.item.transDate | moment("YYYY-MM-DD") }}</span>
                                    </td>
                                    <td>{{ props.item.clockIn | moment("h:mm a") }}</td>
                                    <td>{{ props.item.clockOut | moment("h:mm a") }}</td>
                                    <td v-if="!isMobile">{{ props.item.createdOn | moment("YYYY-MM-DD") }}</td>
                                    <td>
                                        <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                    </td>
                                    <td v-if="!isMobile">{{ props.item.remarks }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card>   

                    <!--TimeOffs-->
                    <!-- convert to component then share between MyAttendanceDaily and MyAttendanceToday -->
                    <v-card class="elavation-1 mb-10" v-if="!loading && hasTimeOff"> 
                        <v-toolbar flat height="35px">
                            <span class="font-weight-bold ">Time Off</span>
                            <v-spacer></v-spacer>
                            <v-btn icon title="File New Time Off" @click="showPTO" :disabled="disableConditions">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile ? headers_timeoff_mobile: headers_timeoff"
                            :items="my_data.timeoff"
                            hide-actions
                            item-key="timeOffId"
                            :expand="expand"   
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr @click="viewTimeOffDetails(props.item)" title="Click to view details" class="clickable">                                       
                                    <td>
                                        <span v-if="isMobile">{{props.item.transDate | moment("MMM DD")}}</span>
                                        <span v-else>{{props.item.transDate | moment("YYYY-MM-DD")}}</span>
                                    </td>
                                    <td>
                                        <div class="text-xs-left">{{parseFloat(props.item.hours).toFixed(2)}}</div>
                                    </td>
                                    <td>{{ props.item.leaveName }}</td>
                                    <td>
                                        <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                    </td>
                                    <td v-if="!isMobile">{{ props.item.remarks }}</td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card> 

                    <!--Overtime-->
                    <!-- convert to component then share between MyAttendanceDaily and MyAttendanceToday -->
                    <v-card class="elavation-1" v-if="!loading && hasOvertime"> 
                        <v-toolbar flat height="35px">
                            <span class="font-weight-bold ">Overtime</span>
                            <v-spacer></v-spacer>
                            <v-btn icon small title="File Overtime" @click="showOvertime" :disabled="disableConditions">
                                <v-icon>add</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-data-table
                            :headers="isMobile?headers_overtime_mobile:headers_overtime"
                            :items="my_data.overtime"
                            hide-actions
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr @click="viewOvertime(props.item)" title="Click to view details" class="clickable">
                                    <td>{{ props.item.startTime | moment("hh:mm a") }} - {{ props.item.endTime | moment("hh:mm a") }}</td>
                                    <td>{{ props.item.hoursStr }}</td>
                                    <td v-if="!isMobile">{{ props.item.breakTime }}</td>
                                    <td>{{ props.item.chargeableHours }}</td>
                                    <td>
                                        <span v-if="props.item.offsetOrPay==1">Time Off in Lieu (TOIL)</span>
                                        <span v-if="props.item.offsetOrPay==2">Payroll (Paid Overtime)</span>
                                    </td>
                                    <td v-if="!isMobile">
                                        <b :class="commonfn.getStatusColor(props.item.status)">{{commonfn.getStatusDescription(props.item.status)}}</b>
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </v-card><br>
            </v-flex>
            </v-layout>
        </v-flex>
        
        <v-dialog v-model="dialogAttendanceCorrections" width="600" persistent>   
            <att-corrections ref="addAttCorrections" @send="attCorrectionsHandler" :dialogAttendanceCorrections.sync="dialogAttendanceCorrections"></att-corrections>
        </v-dialog>
        <v-dialog v-model="dialogPTO" width="600" persistent>   
            <pto-component ref="ptoComponentRef" @send="ptoHandler" :dialogPTO.sync="dialogPTO"></pto-component>
        </v-dialog>
        <v-dialog v-model="dialogOvertime" width="600" persistent>   
            <overtime ref="overtimeRef" @send="overtimeHandler" :dialogOvertime.sync="dialogOvertime"></overtime>
        </v-dialog>
        <v-dialog v-model="dialogPicViewer" fullscreen hide-overlay transition="dialog-bottom-transition">   
            <pic-viewer ref="picViewerRef" :dialogPicViewer.sync="dialogPicViewer"></pic-viewer>
        </v-dialog>
    </v-layout>  
</template>
<script>
import myAttendanceApi from '@/api/myattendance'
import commonfn from '@/common/functions'
import { hasAddRights } from '@/helpers/access-permissions'

export default {  
    name: 'MyAttendanceDaily',
    metaInfo: {
        title: 'My Attendance',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'File Attendance Corrections, Overtime, Personal Time Off, Task Charges on selected Date' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'att-corrections': () => import('@/components/Attendance/AttendanceCorrections'),
        'pto-component': () => import('@/components/Attendance/TimeOff'),
        'overtime': () => import('@/components/Attendance/Overtime'),
        'pic-viewer': () => import('@/components/Attendance/AttendancePicViewer'),
    },      
    data () {
        return {       
            commonfn,
            headers_attendance_mobile: [
                {text: 'Action',align: 'left',value: 'code',width: '25%', sortable:false},
                {text: 'Time',align: 'left',value: 'code',width: '25%', sortable:false},        
                {text: 'Pic',align: 'left',value: 'hours',width: '15%', sortable:false},
                {text: 'Device',align: 'left',value: 'hours',width: '30%', sortable:false},
            ],
            headers_attendance: [
                {text: 'Action',align: 'left',value: 'code',width: '15%', sortable:false},
                {text: 'Time',align: 'left',value: 'code',width: '15%', sortable:false},
                {text: 'Pic',align: 'left',value: 'hours',width: '20%', sortable:false},
                {text: 'Device',align: 'left',value: 'hours',width: '25%', sortable:false},
                {text: 'Remarks',align: 'left',value: 'hours',width: '25%', sortable:false},
            ],
            headers_attendance_corrections: [
                {text: 'Date',align: 'left',value: '', width: '15%', sortable:false},
                {text: 'Clock-In',align: 'left',value: '', width: '15%', sortable:false},   
                {text: 'Clock-Out',align: 'left',value: '', width: '15%', sortable:false},              
                {text: 'Filed On',align: 'left',value: 'createdOn',width: '15%',sortable:false},
                {text: 'Status',align: 'left',value: 'status',width: '15%',sortable:false},
                {text: 'Remarks',align: 'left',value: 'remarks',width: '25%',sortable:false}
            ],
            headers_attendance_corrections_mobile: [
                {text: 'Date',align: 'left',value: '', width: '15%', sortable:false},
                {text: 'Clock-In',align: 'left',value: '', width: '15%', sortable:false},   
                {text: 'Clock-Out',align: 'left',value: '', width: '15%', sortable:false},        
                {text: 'Status',align: 'left',value: 'status',width: '15%',sortable:false},
            ],
            headers_timeoff: [
                {text: 'Date',align: 'left',value: 'code',width: '10%', sortable:false},
                {text: 'Hours',align: 'left',value: 'duration',width: '15%', sortable:false},
                {text: 'Type',align: 'left',value: 'type',width: '25%', sortable:false},
                {text: 'Status',align: 'left',value: 'status',width: '15%', sortable:false},
                {text: 'Remarks',align: 'left',value: 'remarks',width: '15%',sortable:false}
            ],
            headers_timeoff_mobile: [
                {text: 'Date',align: 'left',value: 'code',width: '30%', sortable:false},
                {text: 'Hours',align: 'left',value: 'duration',width: '10%', sortable:false},
                {text: 'Type',align: 'left',value: 'type',width: '50%', sortable:false},
                {text: 'Status',align: 'left',value: 'status',width: '15%', sortable:false}
            ],
            headers_overtime: [        
                {text: 'Duration',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Total Hours',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Break Time (mins)',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Chargeable Hours',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Charging Type',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Status',align: 'left',value: '',width: '15%', sortable:false},               
            ],
            headers_overtime_mobile: [        
                {text: 'Duration',align: 'left',value: '',width: '15%', sortable:false},
                {text: 'Hours',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Chargeable',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Type',align: 'left',value: '',width: '15%', sortable:false},          
            ],
            toggle_view: 1,   
            loading: false,
            error: false,
            errorMessage: '',
            transDate: null,
            serverDate: null,
            dialogAttendanceCorrections: false,
            dialogPTO: false,
            expand: false,
            dialogOvertime: false,
            dialogPicViewer: false,
            my_data: null
        }   
    },
    methods: {
        viewTask(data) {
            const dt = this.$moment(data.transDate)
            this.$router.push(`/projects/charges/weekly/${dt.year()}/${dt.week()}`)
        },
        async viewPrevious() {
            this.loading = true
            this.my_data = null
            var prevDate = this.$moment(this.transDate).add(-1, 'days').format("YYYY-MM-DD")
            this.transDate = prevDate

            this.updateHeaderTitle()
            await this.getMyAttendance(true)
            this.loading = false

            if (!this.clockedOut && (prevDate==this.$moment(this.serverDate).format("YYYY-MM-DD")))
                this.$router.push(`/myattendance/daily`)
            else
                this.$router.push(`/myattendance/daily/${prevDate}`)
        },
        async viewNext() {
            this.loading = true
            this.my_data = null
            var nextDate = this.$moment(this.transDate).add(1, 'days').format("YYYY-MM-DD")
            this.transDate = nextDate

            this.updateHeaderTitle()
            await this.getMyAttendance(true)
            this.loading = false

            if (!this.clockedOut && (nextDate==this.$moment(this.serverDate).format("YYYY-MM-DD")))
                this.$router.push(`/myattendance/daily`)
            else
                this.$router.push(`/myattendance/daily/${nextDate}`)
        },
        async getMyAttendance(show_loading) {
            try {
                this.loading = show_loading
                const response = await myAttendanceApi.getDaily(this.transDate)
                if (response.status==200) {
                    this.my_data = response.data 
                    this.serverDate = response.data.serverDate.local_date  //this should be replaced with just new Date()
                }
                this.loading = false
            }catch(error) {
                this.error = true
                this.errorMessage = error
            }
        },
        viewOvertime(data) {
            this.$router.push(`/myattendance/overtime/details/${data.overtimeId}`)
        },
        viewTimeOffDetails(data) {
            this.$router.push(`/myattendance/timeoff/details/${data.timeOffId}`)
        },
        showPicViewer(data, action) {
            this.$refs.picViewerRef.viewAttenancePic(data, action)
            this.dialogPicViewer = true
        },
        showOvertime() {
            var data = {
                mode: 'Add',
                transDate: this.transDate,
                overtimeId: 0
            }
            this.$refs.overtimeRef.setParams(data)
            this.dialogOvertime = true
        },
        overtimeHandler() {
            this.getMyAttendance(true)
            this.dialogOvertime = false
        },
        ptoHandler(){
            this.getMyAttendance(true)
            this.dialogPTO = false
        },
        showPTO() {
            //can file 2 types of pto per day, VL 4, SL 4
            var data = {
                withPTO: false,
                mode: 'Add',
                transDate: this.transDate,
                //workShift: `${this.my_data.workShifts.name} (${this.$moment(this.my_data.workShifts.clockStart).format('h:mm a')} - ${this.$moment(this.my_data.workShifts.clockEnd).format('h:mm a')})`,
                duration: '',
                type: null,
                status: 'For Approval',
                remarks: ''
            }
            this.$refs.ptoComponentRef.setParams(data)
            this.dialogPTO = true
        },
        attCorrectionsHandler() {
            this.dialogAttendanceCorrections = false
            this.getMyAttendance()
        },
        viewAttendanceCorrections(data) {
                this.$router.push(`/myattendance/corrections/details/${data.attendanceCorrectionsId}`)
        },
        showAddEditAttCorrections() {
            //only one record per day
            if (this.my_data.attendanceCorrection) {
                this.$router.push(`/myattendance/corrections/details/${this.my_data.attendanceCorrection.attendanceCorrectionsId}`)
            }else{
                const data = {
                    mode: 'Add',
                    attendanceCorrectionsId: null,
                    transDate: this.transDate,
                    workshift: `${this.my_data.workShifts.name} (${this.$moment(this.my_data.workShifts.clockStart).format('h:mm a')} - ${this.$moment(this.my_data.workShifts.clockEnd).format('h:mm a')})` ,
                    clockStart: this.my_data.workShifts.clockStart,
                    clockEnd: this.my_data.workShifts.clockEnd,
                    clockIn: null,
                    clockOut: null,
                    remarks: null,
                    approvedOn: null,
                    attCorrectionsStatus: null,
                }    
                this.$refs.addAttCorrections.setParams(data)
                this.dialogAttendanceCorrections = true
            }
        }, 
        viewThisMonth() {           
            this.$router.push('/myattendance/calendar')
        },
        viewToday() {
            this.$router.push('/myattendance/daily') 
        },
        updateHeaderTitle() {
            //update header titles
            this.$root.$emit('setHeaderTitles', {
                display: true,
                headerTitle: '',
                headerPageTitle: this.$moment(this.transDate).format('ddd, DD MMM YYYY')
            })
        }
    },
    async created() {
        this.transDate = this.$route.params.transDate

        this.updateHeaderTitle()
        await this.getMyAttendance(true)
    }, 
    computed: {  
        canAddAttendanceCorrections(){
            const router = this.$router.resolve({ name: 'AttendanceCorrectionsMain' })
            return hasAddRights(router.route.fullPath)
        },  
        isMobile() {
            return window.innerWidth < 600
        },
        hasOvertime() {
            var hasOT = false
            if (this.my_data != null) {
                if (this.my_data.overtime.length > 0) {
                    hasOT = true
                }
            }
            return hasOT
        },
        hasProjectCharges() {
            var hascharges = false
            if (this.my_data != null) {
                if (this.my_data.projectCharges.length > 0) {
                    hascharges = true
                }
            }
            return hascharges
        },
        hasTimeOff() {
            var hastimeoff = false
            if (this.my_data != null) {
                if (this.my_data.timeoff.length > 0) {
                    hastimeoff = true
                }
            }
            return hastimeoff
        },
        hasAttendance() {
            if (this.my_data != null) {
                return this.my_data.attendance != null
            }
        },
        hasAttendanceCorrection() {
            if (this.my_data != null) {
                return this.my_data.attendanceCorrection != null
            }
        },
        cutoffData() {
            if (this.my_data != null) {
                return this.my_data.cutoff
            }
        },
        hasCutoffData() {
            if (this.my_data != null) {
                return this.my_data.cutoff != null
            }else return true
        },
        cutOffStatus() {
            var cutOffStatus = 0
            if (this.my_data != null) {
                if (this.my_data.cutoff != null) {
                    cutOffStatus = this.my_data.cutoff.status
                }
            }
            return cutOffStatus
        },
        timeReportStatus() {
            var timeReportStatus = 0
            if (this.my_data != null) {
                if (this.my_data.timeReport != null) {
                    timeReportStatus = this.my_data.timeReport.status
                }
            }
            return timeReportStatus
        },
        disableConditions() {
            return (this.loading||
                    this.cutOffStatus==commonfn.getStatusCode('Frozen') || 
                    this.cutOffStatus==commonfn.getStatusCode('Closed') || 
                    this.timeReportStatus==commonfn.getStatusCode('Approved') ||
                    !this.hasCutoffData
                    )  
        },
        futureDate() {
            if (this.$moment(this.transDate).format("YYYY-MM-DD") > this.$moment(this.serverDate).format("YYYY-MM-DD"))
                return true
            else return false
        },
        currentDate() {
            if (this.$moment(this.transDate).format("YYYY-MM-DD") == this.$moment(this.serverDate).format("YYYY-MM-DD"))
                return true
            else return false
        },
        clockedOut() {
            if (this.my_data != null) {
                if (this.my_data.attendance != null) {
                    return this.my_data.attendance.clockOut != null
                }
            }
            return false
        },
        isHoliday() {
            if (!this.loading) {
                return this.my_data.holiday
            }
        },
        holidayDescription() {
            if (!this.loading && this.my_data.holiday) {
                return `${this.my_data.holiday.description} - ${this.my_data.holiday.holidayTypeName}`
            }
        },
        hasNoData() {
            if (!this.loading) return !this.hasTimeOff &&
                                    !this.hasProjectCharges &&
                                    !this.hasAttendance &&
                                    !this.hasAttendanceCorrection &&
                                    !this.hasOvertime
        },
        withAssignedWorkShift() {
            if (!this.loading) return this.my_data.workShifts!=null
        },
        workshift() {
            var workshift = ''
            if (this.my_data) {
                if (this.my_data.workShifts) {
                    var strict = this.my_data.workShifts.strict ? 'Strict' : 'Flexible'
                    workshift = this.my_data.workShifts.name + ' (' + this.$moment(this.my_data.workShifts.clockStart).format("h:mm a") + ' - ' + this.$moment(this.my_data.workShifts.clockEnd).format("h:mm a") + ') ' + strict
                }
            }
            return workshift
        },
    }
}
</script>
<style scoped>
.alert {
    margin:0px 0px 5px 0px;
}
.apps-container {
    margin-left:-15px;
}
</style>